import { Injectable } from "@angular/core";
import { Router } from '@angular/router';
@Injectable({
  providedIn: "root"
})
export class AppSessionInteruptService {

  constructor( private router:Router) {}

  stopSession() {
    this.router.navigate(['/login']);
    
  }
}
